import { GlobalEvents } from '@highlight/ipc'
import { AUDIO_RUNTIME_MIC_KIND_EVENT } from '@shared/config/Config'
import type { MicKind } from '@shared/mic-kind'

/** Hands main the kind of mic a meeting's audio session just acquired; main tells the gateway. */
export function reportMicKindToMain(audioSessionId: string, micKind: MicKind): void {
  void GlobalEvents.invoke(AUDIO_RUNTIME_MIC_KIND_EVENT, audioSessionId, micKind).catch((err) => {
    console.error('[AudioTranscription] Failed to deliver mic kind to main:', err)
  })
}
